import useMount from '@src/utils/hooks/use-mount';
import { observable } from 'mobx';
import BaseStore from '@src/utils/store/base-store';
import { noop } from '@src/utils/common-util';
import { autobind } from 'core-decorators';
import { useLayerData } from '@src/utils/hooks/use-layer-data';
import { useEffect } from 'react';
import * as Scroll from 'react-scroll';
class KvBoxStore extends BaseStore {
  constructor(options = {}) {
    super();
    Object.assign(this, options);
  }
  @observable btn_text = '';
  @observable content_text = '';
  @observable logo_gyl = '';
  @observable logo_xsj = '';
  @observable title_text = '';
  @observable characterList = [];
  @observable mainStore;

  @observable redirectLink = noop;

  @autobind
  async init() {}

  /**
   * 跳转到特定屏
   * @param elementName 跳转id
   */
  onScrollToElement = elementName => {
    if (elementName) {
      Scroll.scroller.scrollTo(elementName, {
        duration: 500,
        delay: 0,
        smooth: false,
        offset: -120 // Scrolls to element + 50 pixels down the page
      });
    }
  };

  use() {
    super.use();
    const layerData = useLayerData('part1');

    useEffect(
      () => {
        if (layerData) {
          console.log(layerData, 'part1part1part1part1part1part1part1part1');
          this.btn_text = layerData.btn_text;
          this.content_text = layerData.content_text;
          this.logo_gyl = layerData.logo_gyl;
          this.logo_xsj = layerData.logo_xsj;
          this.title_text = layerData.title_text;
          this.characterList = layerData.characterList;
        }
      },
      [layerData]
    );
    useMount(() => {
      this.init();
    });
  }
}

export default KvBoxStore;
